<template>
  <div>
    <p class="page-container">
      没有找到你要的页面<br />你是不是迷路了?

      <router-link to="/">点击返回首页 </router-link>
    </p>
  </div>
</template>
<script>
import { account_info_GetIndex } from "../api/api";

import router from "@/router";
import { resetRouter, filterAsyncRouter } from "@/router/index";

export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {
    var _this = this;
    console.log(_this.$route);
    console.log(_this.$route);
    // if( window.localStorage.TokenExpire)

    if (!_this.$route.query.redirect) {
            console.log(_this.$route);
      var curTime = new Date();
      var TokenExpire = new Date(Date.parse(window.localStorage.TokenExpire));
      if (
        TokenExpire <= curTime ||
        window.localStorage.TokenExpire == "" ||
        window.localStorage.TokenExpire == "undefined"
      ) {
        if (
          _this.$route.redirectedFrom
            .toLowerCase()
            .indexOf('order_management') > -1
        ) {
          this.$router.push({
            path: '/login',
            query: {
              redirect: _this.$route.redirectedFrom,
            },
          })
        } else {
          this.$router.push({
            path: '/jump_link',
            query: {
              redirect: _this.$route.redirectedFrom,
            },
          })
        }
        // this.$router.push({
        //   path: "/login",
        //   query: {
        //     redirect: _this.$route.redirectedFrom,
        //   },
        // });
        return;
      }
      this.$router.push({
        path: "/",
      });
      return;
    }
       console.log(_this.$route.query.redirect
            .toLowerCase()
            .indexOf('order_management') > -1);
      if (
          _this.$route.query.redirect
            .toLowerCase()
            .indexOf('order_management') > -1
        ) {
          this.$router.push({
            path: '/login',
            query: {
              redirect: _this.$route.query.redirect,
            },
          })
        } else {
          this.$router.push({
            path: '/jump_link',
            query: {
              redirect: _this.$route.query.redirect,
            },
          })
        }
    // this.$router.push({
    //   path: "/login",
    //   query: {
    //     redirect: _this.$route.query.redirect,
    //   },
    // });
  },
};
</script>
<style >
.page-container {
  font-size: 25px;
  text-align: center;
  color: rgb(192, 204, 218);
}

.router-link-active {
  font-size: 14px;
}
</style>
